var _defs, _path, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReturn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22,8v2c2.2061,0,4,1.7944,4,4s-1.7939,4-4,4h-12v-5l-6,6,6,6v-5h12c3.3086,0,6-2.6914,6-6s-2.6914-6-6-6Z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "_Transparent_Rectangle_",
    "data-name": "&lt;Transparent Rectangle&gt;",
    className: "cls-1",
    width: 32,
    height: 32
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReturn);
export default __webpack_public_path__ + "static/media/return.3b276ebd41251225bfeaa6edc754392c.svg";
export { ForwardRef as ReactComponent };